import React from 'react';

import { Radio } from '@mui/material';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './RemoteCoachRow.module.scss';
import { AvatarIcon } from '../../../../../../../shared/components/ui-components';
import { Coach } from '../../../../../../interfaces/coachList/CoachListInfo';
import { getCoachDescription } from './utils/getCoachDescription';
import { SelectableCard } from '../../../../../../../shared/components/form-components';

type RemoteCoachRowProps = {
  coach: Coach;
  selectedCoachId?: number | null;
  onClick: (coach: Coach) => void;
};

const RemoteCoachRow = ({ coach, onClick, selectedCoachId }: RemoteCoachRowProps) => {
  const checked = selectedCoachId === coach.coachId;

  const handleClick = () => {
    onClick(coach);
  };

  return (
    <SelectableCard
      variant="outBox"
      className={classes.row}
      onClick={handleClick}
      data-test-id="coach-row"
    >
      <Radio checked={checked} />
      <AvatarIcon userName={coach.coachName} avatarImgLink={coach.coachAvatar} />
      <TitleWithDescription
        title={coach.coachName}
        description={getCoachDescription(coach)}
        titleFont="body-14-bold"
        descriptionColor="main-black"
      />
      {coach.bio && <p className={classes.bio}>&quot;{coach.bio}&quot;</p>}
    </SelectableCard>
  );
};

export { RemoteCoachRow };
